import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hana_admin_token");
  if (token && config.url?.includes("/admin")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const adminLogin = async (username, password) => {
  const { data } = await api.post("/admin/login", { username, password });
  localStorage.setItem("hana_admin_token", data.token);
  localStorage.setItem("hana_admin_role", data.role || "owner");
  localStorage.setItem("hana_admin_username", data.username);
  return data;
};

export const adminLogout = () => {
  localStorage.removeItem("hana_admin_token");
  localStorage.removeItem("hana_admin_role");
  localStorage.removeItem("hana_admin_username");
};
export const isAdmin = () => !!localStorage.getItem("hana_admin_token");
export const getAdminRole = () => localStorage.getItem("hana_admin_role") || "owner";
export const getAdminUsername = () => localStorage.getItem("hana_admin_username") || "";
